var $fcc824e339304bf1$exports = {};
$fcc824e339304bf1$exports = {
    "(optional)": `(iste\u{11F}e ba\u{11F}l\u{131})`,
    "(required)": `(gerekli)`
};


export {$fcc824e339304bf1$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
